import { render } from "./LoadingComponent.vue?vue&type=template&id=3ad06892"
const script = {}

import "./LoadingComponent.vue?vue&type=style&index=0&id=3ad06892&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__